<template>
  <div>
    <button
      class="config-btn rounded-l border-r border-gray-700"
      :class="state.transformActive ? 'bg-copper-800' : 'bg-gray-800'"
      @click="toggleDisplay"
    >
      <IconsThickness />
    </button>
    <button class="config-btn bg-gray-800 rounded-r" @click="toggleVisibility">
      <div>
        <EyeIcon v-if="state.visible" class="m-auto w-5 h-5" />
        <EyeSlashIcon v-else class="m-auto text-gray-600 w-5 h-5" />
      </div>
    </button>
  </div>
</template>

<script lang="ts" setup>
import { reactive } from 'vue'
import IconsThickness from '@/components/icons/Thickness.svg'
import { EyeIcon, EyeSlashIcon } from '@heroicons/vue/24/solid'

type State = {
  visible: boolean
  transformActive: boolean
}

const emit = defineEmits(['toggle-visibility', 'toggle-display'])

const state = reactive<State>({
  visible: true,
  transformActive: false,
})

function toggleVisibility() {
  emit('toggle-visibility', state.visible)
  state.visible = !state.visible
}

function toggleDisplay() {
  emit('toggle-display', state.transformActive)
  state.transformActive = !state.transformActive
}
</script>

<style scoped>
.config-btn {
  @apply py-1.5 px-2.5 h-8;
}
</style>
